import { NavController, NavParams, App, ModalController, ViewController, ToastController, Content } from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { AuthProvider } from '../../../../providers/auth/auth';
import { EmployeeRhProvider } from '../../../../providers/employeerh/employeerh';


@Component({
    selector: 'page-rh-barometer',
    templateUrl: 'rh-barometer.html',
})
export class RhBarometerPage implements OnInit {
    // DOMVar
    barometer_id: any = null;

    // questions handling
    questions = [];
    answers = [];

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public storageProvider: Storage,
        public app: App,
        public authProvider: AuthProvider,
        public employeeRhProvider: EmployeeRhProvider,
        public viewCtrl: ViewController,
        public toastCtrl: ToastController
    ) {
        this.barometer_id = this.navParams.get('barometer_id');
    }

    ngOnInit() {
        console.log("loaded", this.barometer_id)
        this.loadCampaign();
    }

    loadCampaign() {
        this.employeeRhProvider.getBarometerCampaignQuestions(this.barometer_id).subscribe((res) => {
            if(res.success){
                for (const q of res.data) {
                    this.questions.push({
                        id: q.id,
                        title: q.question,
                        label: q.label
                    })
                }
            }
        })
    }

    setRangeAnswer(id, value, qIndex) {
        this.answers.push({
            question_id: id,
            value: value
        })
        this.questions.splice(qIndex, 1)
    }

    submitAnswer(){
        this.employeeRhProvider.storeBarometerUserAnswers(this.barometer_id, this.answers).subscribe((res) => {
            if(res.success){
                let toast = this.toastCtrl.create({ message: "Vos réponses ont été envoyées", duration: 6000, position: 'top'});
                toast.present();
                this.dismiss();
            }
        })
    }



    // Modal ctrl
    dismiss() {
        this.viewCtrl.dismiss();
    }


}



// WEBPACK FOOTER //
// ./src/pages/employee/_rh/rh-barometer/rh-barometer.ts